// extracted by mini-css-extract-plugin
export var section = "xvFlCVlD";
export var container = "Sho-NcOH";
export var stats = "kkCHzEkZ";
export var stat = "HiS52GAI";
export var statVisible = "yQdqtyCV";
export var number = "TpOVICkH";
export var numberSuffix = "+SiIu6cP";
export var title = "_4CCQnL0H";